var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"breathe"},[_c('div',{ref:"inner",staticClass:"inner breathe"})])}
var staticRenderFns = []

export { render, staticRenderFns }